import { Component, OnInit } from '@angular/core';
import { RestAPIService } from 'src/app/services/restapi.service';
import { SampleModel } from 'src/app/modules/dashboard/models/SampleModel';
import { environment } from 'src/environments/environment';
import { LoginResponseModel } from 'src/app/modules/login/models/loginResponseModel';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  constructor(public _restAPI: RestAPIService, private router: Router) { 
    this._restAPI.loading  = false;               
  }

  sampleData: Array<SampleModel> = [];

  ngOnInit() {
    const tokenDatajson = localStorage.getItem('token_data');
    if(tokenDatajson){
      let tokenData: LoginResponseModel = JSON.parse(tokenDatajson);
      if(!((tokenData.claims?.length??0) > 0))
        this.router.navigate(['/unauthorized']);
    }
    //this.getRecords();
  }

  async getRecords() {
    this._restAPI.loading  = true;
    this._restAPI.get<Array<SampleModel>>(environment.apiURL).subscribe({
        next: (data) => {
            this._restAPI.loading  = false;
            this.sampleData = data;
            console.log(this.sampleData);
        },
        error: (error) => {this._restAPI.loading  = false;console.error(error)}
    });
    
    return this.sampleData;
  }

  async createRecord() {
    this._restAPI.loading  = true;
    let request = {id: 1}

    this._restAPI.post<SampleModel>(environment.apiURL, request).subscribe({
        next: (data) => {
          this._restAPI.loading  = false;
            console.log("created successfully");
        },
        error: (error) => {this._restAPI.loading  = false;console.error(error)}
    });
  }
}
